import { useEffect, useRef, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useTranslation } from "react-i18next";
import { BiSolidError } from "react-icons/bi";
import { FaUpload, FaWheelchair } from "react-icons/fa";
import { IoCloseSharp } from "react-icons/io5";
import { RiDeleteBin6Fill, RiEditFill } from "react-icons/ri";
import { BsCalendarCheck } from "react-icons/bs";
import { MdOutlineCancel, MdOutlineEdit } from "react-icons/md";
import ActionMenu from "../../../../component/ActionMenu";
import { TbFilterSearch } from "react-icons/tb";
import "react-loading-skeleton/dist/skeleton.css";
import { useSelector } from "react-redux";
import { NavLink, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  getStatusBadge,
  getStatusText,
} from "../../../../component/admin/VehiclesTable";
import BusingSubscriptions from "../../../../component/Model/reservation/BusingSubscription";
import BusingSubscriptionFilters from "../../../../component/Model/reservation/BusingSubscriptionFilters";
import CancelReservation from "../../../../component/Model/reservation/CancelReservation";
import AdminPagination from "../../../../component/pagination/AdminPagination";
import SkeletonLoading from "../../../../component/SkeletonLoading";
import Tooltip from "../../../../component/Tooltip";
import i18n from "../../../../i8next";
import {
  useDeleteReservationMutation,
  useGetAllReservationsQuery,
  useGetReservationDetailsQuery,
  useGetReservationStudentsQuery,
  useRemoveStudentFromReservationMutation,
  useUpdateBusingSubscriptionMutation,
  useUpdateReservationMutation,
  useUploadStudentListMutation,
} from "../../../../store/api/school/ReservationSlice";
import UnassignDriverModal from "../../../../component/Model/reservation/UnassignDriverModal";
import RemoveStudentModal from "../../../../component/Model/reservation/RemoveStudentModal";
import SeatWarningModal from "../../../../component/Model/reservation/SeatWarningModal";
import { multiPartData2 } from "../../../../utils";
import {
  convertTime,
  formatDateToLocal,
} from "../../../../utils/dateAndTimeConversion";
import BusingAssignDriver from "../BusingAssignDriver";

const initialPagination = {
  limit: 10,
  page: 1,
  total: "",
  totalPages: "",
};

const BusingSubscriptionList = () => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const [editModelShow, setEditModelShow] = useState(false);
  const [showDetail, setShowDetail] = useState(false);
  const [bookingCancelModal, setBookingCancelModal] = useState(false);
  const [id, setId] = useState("");
  const [bookingCancelId, setBookingCancelId] = useState("");
  const handleCloseBookingCancelModal = () => setBookingCancelModal(false);
  const handleEditModelClose = () => setEditModelShow(false);
  const handleCloseDetail = () => setShowDetail(false);
  const [selectedReservation, setSelectedReservation] = useState(null);
  const [bookingDetails, setBookingDetails] = useState({});
  const [reservations, setReservations] = useState([]);
  const [pagination, setPagination] = useState(initialPagination);
  const [filters, setFilters] = useState({});

  // role validation
  // const { user } = useSelector((state) => state.UserReducer);
  // const { role, slug } = useParams();

  const { user } = useSelector((state) => state.UserReducer);
  const role = user?.role;

  // slug
  const { slug } = useParams();

  // Get Role From React Redux
  const isAdmin = user?.role === "super_admin";

  const [open, setOpen] = useState(false);

  const [showCancelModal, setShowCancelModal] = useState(false);
  const handleCloseCancelModal = () => setShowCancelModal(false);
  const [reservationId, setReservationId] = useState(null);
  const [charterFrequency, setCharterFrequency] = useState("");

  // Reservation detail modal data
  const detailId = showDetail ? bookingDetails?.id : null;
  const { data: studentsData, isLoading: isStudentsLoading } =
    useGetReservationStudentsQuery(
      { id: detailId, limit: 50 },
      { skip: !detailId },
    );
  const { data: reservationDetails, isLoading: isDetailsLoading } =
    useGetReservationDetailsQuery(detailId, { skip: !detailId });

  // Get All Reservation
  const { data, isSuccess, isLoading, isFetching, refetch } =
    useGetAllReservationsQuery({
      endPoint: "busing-subscription/transferred",
      page: pagination.page,
      limit: pagination.limit,
      ...filters,
      role: "vendor",
    });

  // delete query
  const [deleteReservation, { isLoading: isDeleteLoading }] =
    useDeleteReservationMutation();

  const [updateReservation, { isLoading: isUpdateLoading }] =
    useUpdateReservationMutation();

  useEffect(() => {
    if (isSuccess && data?.data) {
      setReservations(data.data.reservations);
      setPagination((prev) => ({ ...prev, ...data.data.pagination }));
    }
  }, [data, isSuccess]);

  // model show function
  const handleShow = (id) => {
    setShow(true);
    setId(id);
  };

  const handleApplyFilters = (data) => {
    setFilters(data);
    setOpen(false);
  };

  // delete function
  const handleDelete = async () => {
    toast.dismiss();
    try {
      const response = await deleteReservation({
        endPoint: "busing-subscription",
        id,
      }).unwrap();
      if (response.statusCode === 200) {
        toast.success(response.message);
        setShow(false);
        setId("");
      }
    } catch (err) {
      const mesg = err.data?.message || "Something went wrong";
      toast.error(mesg);
    }
  };

  const handlePageChange = (page) => {
    setPagination((prev) => ({ ...prev, page }));
  };

  const handleLimitChange = (limit) => {
    setPagination((prev) => ({
      ...prev,
      limit,
      page: 1,
    }));
  };

  const handleResetFilters = () => {
    setFilters({});
    setPagination(initialPagination);
  };

  const handleShowEditModel = (item) => {
    setSelectedReservation(item);
    setEditModelShow(true);
  };

  const handleBookingDetails = (item) => {
    setBookingDetails(item);
    setShowDetail(true);
  };

  const handleRideCancel = async (e) => {
    e.preventDefault();
    toast.dismiss();

    const formdatas = multiPartData2({ status: "cancelled" });

    try {
      let response = await updateReservation({
        data: formdatas,
        id: bookingCancelId,
      }).unwrap();

      if (response.statusCode === 200 || response.statusCode === 201) {
        toast.success(response.message);
        setBookingCancelModal(false);
        setBookingCancelId("");
      }
    } catch (err) {
      const mesg = err.data?.message || "Something went wrong";
      toast.error(mesg);
    }
  };

  // Language Change Handler
  useEffect(() => {
    const h = () => {
      refetch?.();
    };
    i18n.on("languageChanged", h);
    return () => i18n.off("languageChanged", h);
  }, [refetch]);

  // Helper function to format text
  const formatText = (text) => {
    if (!text) return "";
    return text.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
  };

  const [showUnassignConfirm, setShowUnassignConfirm] = useState(false);

  const handleCancelReservation = (data) => {
    setShowCancelModal(false);
    setShowDetail(false);
    refetch();
  };

  const [uploadStudentList, { isLoading: isUploading }] =
    useUploadStudentListMutation();

  const [updateBusingSubscription, { isLoading: isUpdatingSeats }] =
    useUpdateBusingSubscriptionMutation();

  const [removeStudentFromReservation, { isLoading: isRemovingStudent }] =
    useRemoveStudentFromReservationMutation();

  const [removeStudentTarget, setRemoveStudentTarget] = useState(null); // { reservationId, studentId, studentName }

  const handleRemoveStudent = (reservationId, studentId, studentName) => {
    setRemoveStudentTarget({ reservationId, studentId, studentName });
  };

  const confirmRemoveStudent = async () => {
    if (!removeStudentTarget) return;
    toast.dismiss();
    try {
      await removeStudentFromReservation({
        reservationId: removeStudentTarget.reservationId,
        studentId: removeStudentTarget.studentId,
      }).unwrap();
      toast.success(`${removeStudentTarget.studentName} removed successfully.`);
      setRemoveStudentTarget(null);
    } catch (err) {
      toast.error(err?.data?.message || "Failed to remove student.");
    }
  };

  const [uploadTargetItem, setUploadTargetItem] = useState(null);
  const [seatWarning, setSeatWarning] = useState(null);
  const fileInputRef = useRef(null);

  const handleUploadClick = (item) => {
    setUploadTargetItem(item);
    fileInputRef.current.value = "";
    fileInputRef.current.click();
  };

  const doUpload = async (reservationId, file) => {
    const result = await uploadStudentList({
      id: reservationId,
      file,
    }).unwrap();
    return result.data;
  };

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file || !uploadTargetItem) return;

    try {
      const data = await doUpload(uploadTargetItem.id, file);
      toast.success(
        `${data?.inserted ?? 0} students assigned. ${data?.duplicates ?? 0} already assigned.`,
      );
      setUploadTargetItem(null);
    } catch (err) {
      const errData = err?.data;
      if (errData?.code === "SEAT_LIMIT_EXCEEDED") {
        const vehicleSeats = parseInt(uploadTargetItem.vehicle?.seats, 10) || 0;
        setSeatWarning({
          reservationId: uploadTargetItem.id,
          reservedSeats: errData.data?.reserved_seats ?? 0,
          currentStudents: errData.data?.current_students ?? 0,
          csvRows: errData.data?.new_students ?? 0,
          file,
          vehicleSeats,
        });
      } else {
        toast.error(errData?.message || "Upload failed.");
        setUploadTargetItem(null);
      }
    }
  };

  const handleIncreaseAndUpload = async () => {
    const newSeats = seatWarning.currentStudents + seatWarning.csvRows;
    toast.dismiss();
    try {
      await updateBusingSubscription({
        id: seatWarning.reservationId,
        data: { reserved_seats: newSeats },
      }).unwrap();
      const data = await doUpload(seatWarning.reservationId, seatWarning.file);
      toast.success(
        `Reserved seats increased to ${newSeats}. ${data?.inserted ?? 0} students assigned.`,
      );
      setSeatWarning(null);
      setUploadTargetItem(null);
    } catch (err) {
      toast.error(err?.data?.message || "Operation failed.");
    }
  };

  return (
    <>
      <div className="d-flex flex-wrap align-items-center justify-content-between">
        <div className="mb-2 total">
          {t("total")} {t("reservations")}: {pagination?.total}
        </div>

        <div className="mb-2 filterBox">
          <ul className="d-flex flex-wrap align-items-center p-0 transactionsFilter">
            {role === "school" && (
              <NavLink to="/busing-subscriptions/vendors">
                <Button className="searchBtn">{t("btns.reserve")}</Button>
              </NavLink>
            )}

            <li>
              <button
                type="button"
                className={`btn ${
                  open ? "btn-primary" : "btn-primary"
                } d-flex align-items-center gap-2`}
                onClick={() => setOpen(!open)}
              >
                {open ? (
                  <>
                    <TbFilterSearch /> {t("btns.hide")} {t("btns.filters")}
                  </>
                ) : (
                  <>
                    <TbFilterSearch /> {t("show")} {t("btns.filters")}
                  </>
                )}
              </button>
            </li>
          </ul>
        </div>
      </div>

      <BusingSubscriptionFilters
        open={open}
        role="school"
        onReset={handleResetFilters}
        handleApplyFilters={handleApplyFilters}
      />

      <div className="table m-0">
        <table>
          <thead>
            <tr>
              <th className="text-nowrap">
                {t("Sr")}.{t("no")}.
              </th>
              {/* <th>{t("school")}</th> */}
              <th className="text-nowrap">
                {t("driver")} {t("name")}
              </th>
              <th className="text-nowrap">
                {t("booking")} {t("type")}
              </th>
              <th className="text-nowrap">
                {t("subscription")} {t("type")}
              </th>
              <th className="text-nowrap">
                {t("vehicle")} {t("type")}
              </th>
              <th className="text-nowrap">
                {t("vehicle")} {t("License")} {t("plate")}
              </th>
              <th className="text-nowrap">
                {t("start")} {t("date")}
              </th>
              <th className="text-nowrap">
                {t("end")} {t("date")}
              </th>
              <th className="text-nowrap">
                {t("start")} {t("time")}
              </th>
              {/* <th className="text-nowrap">
                {t("end")} {t("time")}
              </th> */}
              <th className="text-nowrap">
                {t("reserved")} {t("seats")}
              </th>
              <th>{t("status")}</th>
              {role === "vendor" && (
                <th className="text-nowrap">
                  {t("assign")} {t("driver")}
                </th>
              )}
              <th>{t("action")}</th>
            </tr>
          </thead>
          <tbody>
            {isLoading || isFetching ? (
              <SkeletonLoading
                MainLength={10}
                length={role === "vendor" ? 14 : 13}
              />
            ) : reservations?.length > 0 ? (
              reservations?.map((item, i) => (
                <tr key={i}>
                  <td>{(pagination.page - 1) * pagination.limit + i + 1}</td>
                  {/* <td className="text-nowrap">
                    {item?.school?.company_name || ""}
                  </td> */}
                  <td>{item?.driver?.full_name || "Unassigned"}</td>
                  <td>{formatText(item?.booking_type)}</td>
                  <td>{t(item?.subscription_type) || "N/A"}</td>
                  <td className="text-nowrap">
                    {item?.vehicle?.vehicle_type_name}
                  </td>
                  <td>{item?.vehicle?.license_number}</td>
                  <td className="text-nowrap">
                    {formatDateToLocal(item?.start_date)}
                  </td>
                  <td className="text-nowrap">
                    {item?.end_date ? formatDateToLocal(item.end_date) : "N/A"}
                  </td>
                  <td className="text-nowrap">
                    <div>
                      <small className="text-muted me-1">
                        {item?.subscription_type === "afternoon"
                          ? t("afternoon")
                          : t("morning")}
                        :
                      </small>
                      {item?.start_time ? convertTime(item.start_time) : "—"} –{" "}
                      {item?.end_time ? convertTime(item.end_time) : "—"}
                    </div>
                    {item?.subscription_type === "morning_afternoon" &&
                      item?.return_start_time && (
                        <div className="mt-1">
                          <small className="text-muted me-1">
                            {t("afternoon")}:
                          </small>
                          {convertTime(item.return_start_time)} –{" "}
                          {convertTime(item.return_end_time)}
                        </div>
                      )}
                  </td>
                  <td>{item?.reserved_seats}</td>
                  <td>
                    <span className={getStatusBadge(item?.status)}>
                      {getStatusText(item?.status)}
                    </span>
                  </td>
                  {role === "vendor" && (
                    <td align="center">
                      {item.status !== "pending" ? (
                        "__"
                      ) : (
                        <BusingAssignDriver
                          bookingId={item?.id}
                          status={item.status}
                          role={role}
                          isTransfer={Boolean(
                            item?.school?.id && item?.vendor?.id,
                          )}
                        />
                      )}
                    </td>
                  )}
                  <td>
                    <div className="actionBtn d-flex">
                      <ActionMenu
                        actions={[
                          {
                            label: `${t("reservation")} ${t("details")}`,
                            icon: <BsCalendarCheck />,
                            onClick: () => handleBookingDetails(item),
                          },
                          ...(role === "school"
                            ? [
                                {
                                  label: `${t("edit")}`,
                                  icon: <MdOutlineEdit size={16} />,
                                  onClick: () => handleShowEditModel(item),
                                  disabled: item?.status === "cancelled",
                                },
                                {
                                  label: `${t("cancel")} ${t("reservations")}`,
                                  icon: <MdOutlineCancel size={16} />,
                                  onClick: () => {
                                    setReservationId(item.id);
                                    setCharterFrequency(item.charter_frequency);
                                    setShowCancelModal(true);
                                  },
                                  disabled: item?.status === "cancelled",
                                },
                                {
                                  label: "Upload Students (CSV)",
                                  icon: <FaUpload />,
                                  onClick: () => handleUploadClick(item),
                                  disabled:
                                    (isUploading &&
                                      uploadTargetItem?.id === item.id) ||
                                    item?.status === "cancelled",
                                },
                                {
                                  label: `${t("delete")}`,
                                  icon: <RiDeleteBin6Fill />,
                                  onClick: () => handleShow(item.id),
                                  danger: true,
                                  hidden: ![
                                    "cancelled",
                                    "completed",
                                    "pending",
                                  ].includes(item?.status),
                                },
                              ]
                            : []),
                        ]}
                      />
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr className="text-center">
                <td colSpan="15">
                  <div>
                    <span>
                      {t("no")} {t("reservation")} {t("found")}
                    </span>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Hidden file input for student CSV upload */}
      <input
        type="file"
        ref={fileInputRef}
        accept=".csv"
        style={{ display: "none" }}
        onChange={handleFileChange}
      />

      {/* Pagination */}
      <AdminPagination
        totalPages={pagination.totalPages}
        currentPage={pagination.page}
        limit={pagination.limit}
        onPageChange={handlePageChange}
        onLimitChange={handleLimitChange}
      />

      {/* Booking Details Modal */}
      <Modal
        show={showDetail}
        onHide={handleCloseDetail}
        size="lg"
        centered
        backdrop="static"
        className="detailModel"
      >
        <Modal.Header closeButton className="border-0 position-relative">
          <Modal.Title className="w-100 text-center">
            <h4 className="mb-0 fw-bold text-white">
              <i className="fas fa-bus me-2"></i>
              {t("reservation")} {t("details")}
            </h4>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body
          className="pt-0"
          style={{
            maxHeight: "80vh",
            overflowY: "auto",
          }}
        >
          <div className="reservation-details-container">
            {/* Header Card with Status */}
            <div className="header-card mb-4 mt-2">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <div className="reservation-id">
                    <span className="badge bg-light text-dark fs-6">
                      <i className="fas fa-hashtag me-2"></i>
                      {t("booking")} {t("ID")}:{" "}
                      <strong>{bookingDetails?.id || "N/A"}</strong>
                    </span>
                  </div>
                  {/* <h5 className="mt-2 fw-bold text-dark">
                    {role === "school" &&
                      (bookingDetails?.school?.company_name || "N/A")}

                    {role === "vendor" &&
                      (bookingDetails?.vendor?.company_name || "N/A")}
                  </h5> */}
                </div>
                <div>
                  <span className={getStatusBadge(bookingDetails?.status)}>
                    {getStatusText(bookingDetails?.status)}
                  </span>
                </div>
              </div>
            </div>

            {/* Main Information Grid */}
            <div className="info-grid mb-4">
              <div className="row">
                {/* Left Column */}
                <div className="col-md-6">
                  {bookingDetails?.school && (
                    <div className="info-card mb-3">
                      <div className="info-header">
                        <i className="fas fa-calendar-alt me-2 text-primary"></i>
                        <h6 className="mb-0 fw-bold">
                          {t("school")} {t("information")}
                        </h6>
                      </div>
                      <div className="info-body">
                        <div className="info-item">
                          <span className="info-label">
                            <i className="fas fa-tag me-2"></i>
                            {t("full")} {t("name")}:
                          </span>
                          <span className="info-value">
                            {bookingDetails?.school?.full_name}
                          </span>
                        </div>
                        <div className="info-item">
                          <span className="info-label">
                            <i className="fas fa-tag me-2"></i>
                            {t("email")}:
                          </span>
                          <span className="info-value">
                            {bookingDetails?.school?.email}
                          </span>
                        </div>
                        <div className="info-item">
                          <span className="info-label">
                            <i className="fas fa-bus me-2"></i>
                            {t("company")} {t("name")}:
                          </span>
                          <span className="info-value">
                            {bookingDetails?.school?.company_name}
                          </span>
                        </div>
                      </div>
                    </div>
                  )}

                  {bookingDetails?.vendor && (
                    <div className="info-card mb-3">
                      <div className="info-header">
                        <i className="fas fa-user-tie me-2 text-primary"></i>
                        <h6 className="mb-0 fw-bold">
                          {t("vendor")} {t("information")}
                        </h6>
                      </div>
                      <div className="info-body">
                        <div className="info-item">
                          <span className="info-label">
                            <i className="fas fa-user me-2"></i>
                            {t("full")} {t("name")}:
                          </span>
                          <span className="info-value">
                            {bookingDetails?.vendor?.full_name || "N/A"}
                          </span>
                        </div>
                        <div className="info-item">
                          <span className="info-label">
                            <i className="fas fa-user me-2"></i>
                            {t("email")}:
                          </span>
                          <span className="info-value">
                            {bookingDetails?.vendor?.email || "N/A"}
                          </span>
                        </div>
                        <div className="info-item">
                          <span className="info-label">
                            <i className="fas fa-user me-2"></i>
                            {t("company")} {t("name")}:
                          </span>
                          <span className="info-value">
                            {bookingDetails?.vendor?.company_name || "N/A"}
                          </span>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="info-card mb-3">
                    <div className="info-header">
                      <i className="fas fa-calendar-alt me-2 text-primary"></i>
                      <h6 className="mb-0 fw-bold">
                        {t("booking")} {t("information")}
                      </h6>
                    </div>
                    <div className="info-body">
                      <div className="info-item">
                        <span className="info-label">
                          <i className="fas fa-tag me-2"></i>
                          {t("booking")} {t("type")}:
                        </span>
                        <span className="info-value">
                          {formatText(bookingDetails?.booking_type)}
                        </span>
                      </div>
                      <div className="info-item">
                        <span className="info-label">
                          <i className="fas fa-bus me-2"></i>
                          {t("subscription")} {t("type")}:
                        </span>
                        <span className="info-value">
                          {t(bookingDetails?.subscription_type) || "N/A"}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="info-card mb-3">
                    <div className="info-header">
                      <i className="fas fa-bus me-2 text-primary"></i>
                      <h6 className="mb-0 fw-bold">
                        {t("vehicle")} {t("details")}
                      </h6>
                    </div>
                    <div className="info-body">
                      <div className="info-item">
                        <span className="info-label">
                          <i className="fas fa-car me-2"></i>
                          {t("vehicle")} {t("type")}:
                        </span>
                        <span className="info-value">
                          {bookingDetails?.vehicle?.vehicle_type_name || "N/A"}
                        </span>
                      </div>
                      <div className="info-item">
                        <span className="info-label">
                          <i className="fas fa-id-card me-2"></i>
                          {t("license")} {t("plate")}:
                        </span>
                        <span className="info-value">
                          {bookingDetails?.vehicle?.license_number || "N/A"}
                        </span>
                      </div>
                      <div className="info-item">
                        <span className="info-label">
                          <i className="fas fa-users me-2"></i>
                          {t("reserved")} {t("seats")}:
                        </span>
                        <span className="info-value">
                          {bookingDetails?.reserved_seats || 0}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Right Column */}
                <div className="col-md-6">
                  <div className="info-card mb-3">
                    <div className="info-header">
                      <i className="fas fa-user-tie me-2 text-primary"></i>
                      <h6 className="mb-0 fw-bold">
                        {t("driver")} {t("information")}
                      </h6>
                    </div>
                    <div className="info-body">
                      <div className="info-item">
                        <span className="info-label">
                          <i className="fas fa-user me-2"></i>
                          {t("driver")}:
                        </span>
                        <span
                          className={`info-value ${
                            !bookingDetails?.driver?.full_name
                              ? "text-warning"
                              : ""
                          }`}
                        >
                          {bookingDetails?.driver?.full_name || "Unassigned"}
                        </span>
                      </div>
                      <div className="info-item">
                        <span className="info-label">
                          <i className="fas fa-envelope me-2"></i>
                          {t("email")}:
                        </span>
                        <span className="info-value">
                          {bookingDetails?.driver?.email || "—"}
                        </span>
                      </div>
                      <div className="info-item">
                        <span className="info-label">
                          <i className="fas fa-phone me-2"></i>
                          {t("mobile")} {t("no")}.:
                        </span>
                        <span className="info-value">
                          {bookingDetails?.driver?.phone || "—"}
                        </span>
                      </div>
                      <div className="info-item">
                        <span className="info-label">
                          <i className="fas fa-star me-2"></i>
                          {t("rating")}:
                        </span>
                        <span className="info-value">
                          {bookingDetails?.driver?.avg_rating ? (
                            <span>
                              {"★".repeat(
                                Math.round(
                                  Number(bookingDetails.driver.avg_rating),
                                ),
                              )}
                              {"☆".repeat(
                                5 -
                                  Math.round(
                                    Number(bookingDetails.driver.avg_rating),
                                  ),
                              )}{" "}
                              <small className="text-muted">
                                (
                                {Number(
                                  bookingDetails.driver.avg_rating,
                                ).toFixed(1)}{" "}
                                / {bookingDetails.driver.total_ratings}{" "}
                                {t("reviews")})
                              </small>
                            </span>
                          ) : (
                            "—"
                          )}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Route Info */}
                  {(reservationDetails?.data?.route || isDetailsLoading) && (
                    <div className="info-card mb-3">
                      <div className="info-header">
                        <i className="fas fa-route me-2 text-primary"></i>
                        <h6 className="mb-0 fw-bold">
                          {t("route")} {t("information")}
                        </h6>
                      </div>
                      <div className="info-body">
                        {isDetailsLoading ? (
                          <div className="text-center py-2">
                            <div
                              className="spinner-border spinner-border-sm"
                              role="status"
                            />
                          </div>
                        ) : (
                          <>
                            <div className="info-item">
                              <span className="info-label">
                                <i className="fas fa-map-marker-alt me-2"></i>
                                {t("route")} {t("name")}:
                              </span>
                              <span className="info-value">
                                {reservationDetails?.data?.route?.route_name ||
                                  "—"}
                              </span>
                            </div>
                            <div className="info-item">
                              <span className="info-label">
                                <i className="fas fa-map-pin me-2"></i>
                                {t("start")} {t("location")}:
                              </span>
                              <span className="info-value">
                                {reservationDetails?.data?.route
                                  ?.pickup_address || "—"}
                              </span>
                            </div>
                            <div className="info-item">
                              <span className="info-label">
                                <i className="fas fa-flag-checkered me-2"></i>
                                {t("end")} {t("location")}:
                              </span>
                              <span className="info-value">
                                {reservationDetails?.data?.route
                                  ?.dropoff_address || "—"}
                              </span>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  )}

                  <div className="info-card mb-3">
                    <div className="info-header">
                      <i className="fas fa-clock me-2 text-primary"></i>
                      <h6 className="mb-0 fw-bold">{t("schedule")}</h6>
                    </div>
                    <div className="info-body">
                      <div className="info-item">
                        <span className="info-label">
                          <i className="fas fa-calendar-day me-2"></i>
                          {t("start")} {t("date")}:
                        </span>
                        <span className="info-value">
                          {formatDateToLocal(bookingDetails?.start_date)}
                        </span>
                      </div>
                      <div className="info-item">
                        <span className="info-label">
                          <i className="fas fa-calendar-day me-2"></i>
                          {t("end")} {t("date")}:
                        </span>
                        <span className="info-value">
                          {bookingDetails?.end_date
                            ? formatDateToLocal(bookingDetails?.end_date)
                            : "N/A"}
                        </span>
                      </div>
                      <div className="info-item">
                        <span className="info-label">
                          <i className="fas fa-clock me-2"></i>
                          {bookingDetails?.subscription_type === "afternoon"
                            ? t("afternoon")
                            : t("morning")}{" "}
                          {t("start")} {t("time")}:
                        </span>
                        <span className="info-value">
                          {convertTime(bookingDetails?.start_time)}
                        </span>
                      </div>
                      <div className="info-item">
                        <span className="info-label">
                          <i className="fas fa-clock me-2"></i>
                          {bookingDetails?.subscription_type === "afternoon"
                            ? t("afternoon")
                            : t("morning")}{" "}
                          {t("end")} {t("time")}:
                        </span>
                        <span className="info-value">
                          {convertTime(bookingDetails?.end_time)}
                        </span>
                      </div>
                      {bookingDetails?.return_start_time && (
                        <div className="info-item">
                          <span className="info-label">
                            <i className="fas fa-clock me-2"></i>
                            {t("afternoon")} {t("start")} {t("time")}:
                          </span>
                          <span className="info-value">
                            {convertTime(bookingDetails.return_start_time)}
                          </span>
                        </div>
                      )}
                      {bookingDetails?.return_end_time && (
                        <div className="info-item">
                          <span className="info-label">
                            <i className="fas fa-clock me-2"></i>
                            {t("afternoon")} {t("end")} {t("time")}:
                          </span>
                          <span className="info-value">
                            {convertTime(bookingDetails.return_end_time)}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Notes Section */}
            {bookingDetails?.notes && (
              <div className="notes-section mb-4">
                <div className="notes-card">
                  <div className="notes-header">
                    <i className="fas fa-sticky-note me-2 text-info"></i>
                    <h6 className="mb-0 fw-bold">{t("notes")}</h6>
                  </div>
                  <div className="notes-body">
                    <p className="mb-0">
                      <i className="fas fa-quote-left me-2 text-muted"></i>
                      {bookingDetails.notes}
                      <i className="fas fa-quote-right ms-2 text-muted"></i>
                    </p>
                  </div>
                </div>
              </div>
            )}

            {/* Assigned Students */}
            <div className="info-card mb-4">
              <div className="info-header">
                <i className="fas fa-users me-2 text-primary"></i>
                <h6 className="mb-0 fw-bold">
                  {t("assigned")} {t("students")}
                  {studentsData?.data?.pagination?.total != null && (
                    <span
                      className="ms-2 text-muted fw-normal"
                      style={{ fontSize: 13 }}
                    >
                      ({studentsData.data.pagination.total})
                    </span>
                  )}
                </h6>
              </div>
              <div className="info-body p-0">
                {isStudentsLoading ? (
                  <div className="text-center py-4">
                    <div
                      className="spinner-border spinner-border-sm text-primary"
                      role="status"
                    />
                  </div>
                ) : studentsData?.data?.students?.length > 0 ? (
                  <div className="students-table-wrap">
                    <table className="students-table">
                      <thead>
                        <tr>
                          <th style={{ width: 40 }}>#</th>
                          <th>{t("name")}</th>
                          <th>
                            {t("roll")} {t("no")}.
                          </th>
                          <th>{t("parent")}</th>
                          <th>{t("disability")}</th>
                          <th style={{ width: 80 }}>{t("status")}</th>
                          <th style={{ width: 60 }}></th>
                        </tr>
                      </thead>
                      <tbody>
                        {studentsData.data.students.map((s, idx) => (
                          <tr key={s.assignment_id || idx}>
                            <td
                              className="text-center text-muted"
                              style={{ fontSize: 13 }}
                            >
                              {idx + 1}
                            </td>
                            <td>
                              <div className="student-name-cell">
                                <div className="student-avatar">
                                  {(s.student_name || "?")[0].toUpperCase()}
                                </div>
                                <span className="fw-semibold">
                                  {s.student_name || "—"}
                                </span>
                                {s.is_disabled === 1 && (
                                  <span
                                    className="badge bg-warning text-dark ms-1"
                                    style={{ fontSize: 10 }}
                                  >
                                    <FaWheelchair />
                                  </span>
                                )}
                              </div>
                            </td>
                            <td>
                              <span className="roll-badge">
                                {s.roll_number || "—"}
                              </span>
                            </td>
                            <td>
                              <div className="d-flex align-items-center gap-1">
                                <i
                                  className="fas fa-user text-muted"
                                  style={{ fontSize: 11 }}
                                ></i>
                                <span style={{ fontSize: 13 }}>
                                  {s.parent_name || "—"}
                                </span>
                              </div>
                            </td>
                            <td style={{ fontSize: 12 }}>
                              {s.is_disabled ? (
                                <div>
                                  <div className="text-muted">
                                    {s.disability_notes || "—"}
                                  </div>
                                  {s.dr_phone_no && (
                                    <div className="text-muted">
                                      <i className="fas fa-phone me-1"></i>
                                      {s.dr_phone_no}
                                    </div>
                                  )}
                                </div>
                              ) : (
                                <span className="text-muted">—</span>
                              )}
                            </td>
                            <td>
                              <span
                                className={`status-pill ${s.assignment_status === "active" ? "active" : "inactive"}`}
                              >
                                {s.assignment_status || "—"}
                              </span>
                            </td>
                            <td className="text-center">
                              <Tooltip title={`${t("remove")} ${t("student")}`}>
                                <button
                                  className="btn btn-sm btn-outline-danger py-0 px-2"
                                  onClick={() =>
                                    handleRemoveStudent(
                                      bookingDetails?.id,
                                      s.student_id,
                                      s.student_name,
                                    )
                                  }
                                >
                                  <RiDeleteBin6Fill size={13} />
                                </button>
                              </Tooltip>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div
                    className="text-center text-muted py-4"
                    style={{ fontSize: 14 }}
                  >
                    <i
                      className="fas fa-user-slash mb-2 d-block"
                      style={{ fontSize: 22, color: "#ccc" }}
                    ></i>
                    {t("no")} {t("students")} {t("assigned")}
                  </div>
                )}
              </div>
            </div>

            {/* Footer Information */}
            <div className="footer-section">
              <div className="footer-info">
                <div className="row">
                  <div className="col-md-6">
                    <div className="meta-info">
                      <span className="meta-item">
                        <i className="far fa-calendar-plus me-2 text-muted"></i>
                        {t("created")}:{" "}
                        {bookingDetails?.created_at
                          ? formatDateToLocal(bookingDetails.created_at)
                          : "N/A"}
                      </span>
                    </div>
                  </div>
                  <div className="col-md-6 text-end">
                    <div className="meta-info">
                      {bookingDetails?.updated_at && (
                        <span className="meta-item">
                          <i className="far fa-calendar-check me-2 text-muted"></i>
                          {t("updated")}:{" "}
                          {formatDateToLocal(bookingDetails.updated_at)}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className="border-0">
          <div className="d-flex justify-content-between align-items-center w-100 flex-wrap gap-2">
            {!["cancelled", "completed", "expired"].includes(
              bookingDetails?.status,
            ) && (
              <div className="d-flex gap-2">
                {bookingDetails?.driver &&
                  bookingDetails?.status === "scheduled" && (
                    <Button
                      className="btn btn-primary px-3"
                      onClick={() => setShowUnassignConfirm(true)}
                    >
                      Unassign Driver
                    </Button>
                  )}
                {role === "school" && (
                  <Button
                    className="btn btn-primary px-3"
                    onClick={() => {
                      setReservationId(bookingDetails?.id);
                      setCharterFrequency(bookingDetails?.subscription_type);
                      setShowCancelModal(true);
                    }}
                  >
                    {t("cancel")} {t("reservation")}
                  </Button>
                )}
              </div>
            )}
            <Button
              className="btn btn-primary px-4 ms-auto"
              onClick={handleCloseDetail}
            >
              <i className="fas fa-times me-2"></i>
              {t("btns.close")}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      <UnassignDriverModal
        show={showUnassignConfirm}
        onHide={() => setShowUnassignConfirm(false)}
        reservationId={bookingDetails?.id}
        driverName={
          bookingDetails?.driver?.full_name || bookingDetails?.driver_name
        }
        onSuccess={() => {
          setShowDetail(false);
          refetch();
        }}
      />

      {/* Delete Model */}
      <Modal show={show}>
        <Button className="closePopup" onClick={() => setShow(false)}>
          <IoCloseSharp />
        </Button>
        <div className="popupBox p-3 p-md-5">
          <div>
            <div className="text-center mb-3 errorIcon">
              <BiSolidError />
            </div>
            <div className="text-center mb-4 deleteHd">{t("delete-modal")}</div>
            <div className="text-center">
              <Button
                className="smallBtn cancel me-3"
                onClick={() => setShow(false)}
              >
                {t("btns.cancel")}
              </Button>
              <Button
                className="smallBtn auto"
                disabled={isDeleteLoading}
                onClick={handleDelete}
              >
                {isDeleteLoading ? (
                  <div className="spinner-border" role="status">
                    <span className="sr-only p-0"></span>
                  </div>
                ) : (
                  t("btns.delete")
                )}
              </Button>
            </div>
          </div>
        </div>
      </Modal>

      {/* confirmation modal for booking cancel */}
      <Modal show={bookingCancelModal}>
        <Button className="closePopup" onClick={handleCloseBookingCancelModal}>
          <IoCloseSharp />
        </Button>
        <div className="popupBox p-3 p-md-5">
          <div>
            <div className="text-center mb-3 errorIcon">
              <BiSolidError />
            </div>
            <div className="text-center mb-4 deleteHd">
              {t("cancel-reservation")}
            </div>
            <div className="text-center">
              <Button
                className="smallBtn cancel me-3"
                onClick={handleCloseBookingCancelModal}
              >
                {t("no")}
              </Button>
              <Button
                className="smallBtn auto"
                disabled={isUpdateLoading}
                onClick={handleRideCancel}
              >
                {isUpdateLoading ? (
                  <div className="spinner-border" role="status">
                    <span className="sr-only p-0"></span>
                  </div>
                ) : (
                  t("yes")
                )}
              </Button>
            </div>
          </div>
        </div>
      </Modal>

      {editModelShow && (
        <Modal
          show={editModelShow}
          onHide={handleEditModelClose}
          size="lg"
          centered
          backdrop="static"
        >
          <Modal.Header closeButton className="border-0">
            <Modal.Title className="h5">{t("reservations")}</Modal.Title>
          </Modal.Header>
          <BusingSubscriptions
            selectedReservation={selectedReservation}
            onClose={handleEditModelClose}
          />
        </Modal>
      )}

      <CancelReservation
        showCancelModal={showCancelModal}
        handleCloseCancelModal={handleCloseCancelModal}
        handleCancelReservation={handleCancelReservation}
        reservationId={reservationId}
        charterFrequency={charterFrequency}
        endPoint="busing-subscription"
      />

      <style>{`
        .detailModel .modal-dialog {
          max-width: 900px;
        }

        .header-card {
          background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
          padding: 15px 20px;
          border-radius: 10px;
          border-left: 4px solid #f0b342;
        }
        .info-card {
          background: #fff;
          border-radius: 10px;
          border: 1px solid #e0e0e0;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
          overflow: hidden;
        }

        .info-header {
          background: #f8f9fa;
          padding: 12px 15px;
          border-bottom: 1px solid #e0e0e0;
          display: flex;
          align-items: center;
        }

        .info-body {
          padding: 15px;
        }

        .info-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 8px 0;
          border-bottom: 1px dashed #f0f0f0;
        }

        .info-item:last-child {
          border-bottom: none;
        }

        .info-label {
          color: #666;
          font-size: 14px;
          display: flex;
          align-items: center;
        }

        .info-value {
          color: #333;
          font-weight: 500;
          text-align: right;
          max-width: 60%;
          word-break: break-word;
        }

        .location-card {
          border-radius: 10px;
          overflow: hidden;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
          height: 100%;
        }

        .location-header {
          padding: 12px 15px;
          font-weight: 600;
          font-size: 15px;
          display: flex;
          align-items: center;
        }

        .location-body {
          padding: 15px;
          background: #fff;
          min-height: 80px;
          display: flex;
          align-items: center;
        }

        .location-body p {
          color: #444;
          font-size: 14px;
          line-height: 1.5;
        }

        .notes-card {
          background: #fff;
          border-radius: 10px;
          border: 1px solid #e0e0e0;
          overflow: hidden;
        }

        .notes-header {
          background: linear-gradient(135deg, #f8f9fa 0%, #e3f2fd 100%);
          padding: 12px 15px;
          border-bottom: 1px solid #e0e0e0;
          display: flex;
          align-items: center;
        }

        .notes-body {
          padding: 15px;
          background: #fafafa;
          font-style: italic;
          color: #555;
        }

        .footer-section {
          margin-top: 20px;
          padding-top: 15px;
          border-top: 1px dashed #ddd;
        }

        .meta-info {
          display: flex;
          align-items: center;
        }

        .meta-item {
          font-size: 13px;
          color: #777;
          display: inline-flex;
          align-items: center;
        }

        /* Responsive adjustments */
        @media (max-width: 768px) {
          .info-item {
            flex-direction: column;
            align-items: flex-start;
          }

          .info-value {
            text-align: left;
            margin-top: 4px;
            max-width: 100%;
          }

          .location-section .col-md-6 {
            margin-bottom: 15px;
          }
        }

        /* Icon colors */
        .text-primary {
          color: #007bff !important;
        }
        .text-success {
          color: #28a745 !important;
        }
        .text-warning {
          color: #ffc107 !important;
        }
        .text-danger {
          color: #dc3545 !important;
        }
        .text-info {
          color: #17a2b8 !important;
        }

        /* Students Table */
        .students-table-wrap {
          overflow-x: auto;
        }
        .students-table {
          width: 100%;
          border-collapse: collapse;
          font-size: 13.5px;
        }
        .students-table thead tr {
          background: #f8f9fa;
        }
        .students-table thead th {
          padding: 10px 14px;
          font-weight: 600;
          color: #444;
          border-bottom: 1px solid #e0e0e0;
          white-space: nowrap;
        }
        .students-table tbody tr {
          border-bottom: 1px solid #f0f0f0;
          transition: background 0.15s;
        }
        .students-table tbody tr:last-child {
          border-bottom: none;
        }
        .students-table tbody tr:hover {
          background: #f8f9fa;
        }
        .students-table td {
          padding: 10px 14px;
          vertical-align: middle;
        }
        .student-name-cell {
          display: flex;
          align-items: center;
          gap: 10px;
        }
        .student-avatar {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          background: #dee2e6;
          color: #495057;
          font-size: 12px;
          font-weight: 700;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }
        .roll-badge {
          background: #f1f3f5;
          color: #495057;
          padding: 2px 8px;
          border-radius: 4px;
          font-size: 12px;
          font-weight: 500;
          font-family: monospace;
        }
        .status-pill {
          padding: 3px 10px;
          border-radius: 20px;
          font-size: 12px;
          font-weight: 600;
          text-transform: capitalize;
        }
        .status-pill.active {
          background: #e6f9f0;
          color: #1a9e5c;
        }
        .status-pill.inactive {
          background: #f2f2f2;
          color: #888;
        }

      `}</style>

      <SeatWarningModal
        seatWarning={seatWarning}
        onClose={() => setSeatWarning(null)}
        onConfirm={handleIncreaseAndUpload}
        isUpdatingSeats={isUpdatingSeats}
        isUploading={isUploading}
        t={t}
      />
      <RemoveStudentModal
        target={removeStudentTarget}
        onClose={() => setRemoveStudentTarget(null)}
        onConfirm={confirmRemoveStudent}
        isLoading={isRemovingStudent}
        t={t}
      />
    </>
  );
};

export default BusingSubscriptionList;
